import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../../components/Spinner';
import { verifyOTP } from '../../../redux/modules/agentPortal';
import LocalStorageService from '../../../services/local-storage-service';

function StandbyVerificationPage(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { url } = useRouteMatch();
  const { insuranceRequestId } = useParams();
  const [loadingMessage, setLoadingMessage] = useState(true);
  const [message, setMessage] = useState('');
  const [loader, setLoader] = useState(true);
  const [previousButton, setPreviousButton] = useState(false);

  useEffect(() => {
    dispatch(verifyOTP(insuranceRequestId))
      .then(response => {
        if (!response?.error) {
          const today = new Date();
          const tomorrow = today.setDate(today.getDate() + 1);
          setLoadingMessage(false);
          LocalStorageService.store('portal-api-token', response.token);
          LocalStorageService.store('portal-api-token-date', tomorrow);
          setMessage('Verified!  Taking you to the submission portal now');
          history.push(url.replace('email-verification', 'submission'));
        } else {
          setLoadingMessage(false);
          setLoader(false);
          setPreviousButton(true);
          setMessage(response.error);
        }
      });

    return () => {
      setLoadingMessage(true);
      setMessage('');
      setLoader(true);
      setPreviousButton(false);
    };
  }, [insuranceRequestId, dispatch, history, url]);

  return (
    <Flex direction="column" justifyContent="center" minH="50vh">
      {loadingMessage && <Text>Verifying your information...</Text>}
      {message && <Text>{message}</Text>}
      {loader && <LoadingSpinner isInline minHeight="200px" />}
      {previousButton && (
        <Box justifyContent="center" maxW="200px" mx="auto" my={8}>
          <Button
            data-analytics-id="agent-portal-retry-email-verification-button"
            onClick={() => history.push(url.replace('email-verification', 'verify'))}
          >
            Verify Email Address
          </Button>
        </Box>
      )}
    </Flex>
  );
}

StandbyVerificationPage.propTypes = {

};

export default StandbyVerificationPage;
